<template>
  <div>
    <div class="container mx-auto h-auto laptop:h-almostscreen flex-col flex md:justify-between laptop:justify-center laptop:min-700 fullhd:min-900 min-h-0 relative">
      <div class="z-20 p-1 px-5 laptop:ml-12 fullhd:ml-0 md:p-5 laptop:p-0">
        <MARSHeading><div v-html="$t('landing.hero')" /></MARSHeading>
        <p class="mt-30 text-xl" v-html="$t('landing.herotext')" />
        <p class="mt-30 text-2xl text-orange" v-html="$t('landing.heroorange')" />
        <ActionButton target="_self" bg="orange" fg="white" :value="$t('landing.cta')" href="#register" @click="focusInput" />
      </div>
      <div class="w-16 h-16 hidden laptop:block absolute bottom-0 mb-6 left-1/2 -ml-8 z-20">
        <img class="mx-auto" src="~/assets/img/scroll-down-gif.gif" alt="Scroll down indicator">
      </div>
    </div>
    <div
      class="w-full image-discover bg-visualizer-small md:bg-visualizer-medium laptop:bg-visualizer bg-center bg-cover mt-30 lg:mt-0"
    >
      <div class="container h-full mx-auto">
        <div class="flex flex-col justify-around h-full p-5 laptop:ml-24 md:ml-8">
          <div class="xl:w-9/12 w-12/12">
            <MARSTitle text-color="text-white" class="text-xl md:text-2xl laptop:text-45xl md:w-3/4"><div v-html="$t('landing.sellmore')" /></MARSTitle>
            <p class="text-white text-xl" v-html="$t('landing.sellmoretext')" />
          </div>
        </div>
      </div>
    </div>
    <div id="register" class="container mx-auto flex flex-col laptop:flex-row laptop:my-150px pt-10 md:pt-16">
      <div class="laptop:w-5/12 p-5 md:p-0 fullhd:pl-5 fullhd:pr-65px laptop:mx-24 md:mx-8 md:w-5/6">
        <MARSTitle><div v-html="$t('landing.register')" /></MARSTitle>
        <p class="text-xl" v-html="$t('landing.registertext')" />
      </div>
      <div class="laptop:w-5/12 p-5 md:mt-12 laptop:mt-0 laptop:pr-70px lg:p-0 lg:mx-8 laptop:p-0 w-full lg:w-5/6">
        <RegistrationForm ref="registrationForm" />
      </div>
    </div>
    <div class="container mx-auto md:mt-32 laptop:my-150px">
      <div class="mx-5 md:mx-8 laptop:mx-24">
        <MARSTitle><div v-html="$t('landing.advantages')" /></MARSTitle>
        <div class="mt-12 laptop:mt-100px grid grid-cols-1 laptop:grid-cols-4 md:grid-cols-2 gap-x-8 mb-12">
          <div class="w-full px-0 laptop:pl-0 my-6 laptop:my-12">
            <img class="" src="~/assets/img/ico-pc.svg">
            <p class="font-bold my-4 laptop:my-8" v-html="$t('landing.adv-1')" />
            <p v-html="$t('landing.adv-1-text')" />
          </div>
          <div class="w-full px-0 my-6 laptop:my-12">
            <img src="~/assets/img/ico-cart.svg">
            <p class="font-bold my-4 laptop:my-8" v-html="$t('landing.adv-2')" />
            <p v-html="$t('landing.adv-2-text')" />
          </div>
          <div class="w-full px-0 my-6 laptop:my-12">
            <img src="~/assets/img/ico-phone.svg">
            <p class="font-bold my-4 laptop:my-8" v-html="$t('landing.adv-3')" />
            <p v-html="$t('landing.adv-3-text')" />
          </div>
          <div class="w-full px-0 my-6 laptop:my-12">
            <img src="~/assets/img/ico-people.svg">
            <p class="font-bold my-4 laptop:my-8" v-html="$t('landing.adv-4')" />
            <p v-html="$t('landing.adv-4-text')" />
          </div>
        </div>
      </div>
    </div>
    <div class="container mx-auto md:mt-32 laptop:my-150px px-5 md:px-8 laptop:px-24">
      <MARSTitle><div v-html="$t('landing.see-in-action')" /></MARSTitle>
      <div class="container mt-30 laptop:mt-0">
        <!--      <h1 class="mb-30">{{$t('landing.see-in-action')}}</h1>-->
        <div style="position: relative; width: 100%; padding-top: 56.22%;">
          <div class="w-full h-full absolute top-0">
            <iframe v-if="youtubeEnabled && $i18n.locale != 'it'" width="100%" height="100%" src="https://www.youtube.com/embed/4NCU6yGZ9R4?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
            <iframe v-if="!youtubeEnabled && $i18n.locale != 'it'" width="100%" height="100%" src="https://www.youtube-nocookie.com/embed/4NCU6yGZ9R4?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
            <iframe v-if="youtubeEnabled && $i18n.locale == 'it'" width="100%" height="100%" src="https://www.youtube.com/embed/rGy0_ukkC_A?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
            <iframe v-if="!youtubeEnabled && $i18n.locale == 'it'" width="100%" height="100%" src="https://www.youtube-nocookie.com/embed/rGy0_ukkC_A?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
          </div>
        </div>
      </div>
    </div>
    <div class="container mx-auto md:mt-32 laptop:my-150px flex flex-col laptop:flex-row mt-10">
      <div class="order-last laptop:order-first w-full flex laptop:w-1/2 p-5 md:p-0 md:px-8">
        <!--        <div class="mx-auto bg-backgroundgray" style="width:400px; height:400px;"></div>-->
        <img class="w-full h-full" src="~/assets/img/come-funziona-fullhd.jpg" alt="Come funziona?">
      </div>
      <div class="order-first laptop:order-last w-full flex laptop:w-1/2 laptop:ml-24 p-5 laptop:px-12 md:p-0 md:px-8 flex-col laptop:justify-around">
        <div>
          <SubTitle><div v-text="$t('home.create')" /></SubTitle>
        </div>
      </div>
    </div>
    <div class="container mx-auto md:mt-32 laptop:my-150px px-5 md:px-8 laptop:px-24 mb-30">
      <MARSTitle><div v-html="$t('landing.see-how-it-works')" /></MARSTitle>
      <div class="container mt-30 laptop:mt-0">
        <!--      <h1 class="mb-30">{{$t('landing.see-in-action')}}</h1>-->
        <div style="position: relative; width: 100%; padding-top: 56.22%;">
          <div class="w-full h-full absolute top-0">
            <!-- <img class="absolute" style="left:50%; margin-left: -39px;top:50%; margin-top:-34px" src="~/assets/img/video-play.svg" alt="play"/> -->
            <iframe v-if="youtubeEnabled && $i18n.locale == 'it' " width="100%" height="100%" src="https://www.youtube.com/embed/9m5XTOoNOwQ?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
            <iframe v-if="!youtubeEnabled && $i18n.locale == 'it'" width="100%" height="100%" src="https://www.youtube-nocookie.com/embed/9m5XTOoNOwQ?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />

            <iframe v-if="youtubeEnabled && $i18n.locale != 'it'" width="100%" height="100%" src="https://www.youtube.com/embed/hfsruS0u44k?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
            <iframe v-if="!youtubeEnabled && $i18n.locale != 'it'" width="100%" height="100%" src="https://www.youtube-nocookie.com/embed/hfsruS0u44k?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
          </div>
        </div>
      </div>
    </div>
    <div
      class="w-full mt-1/6 bg-darkgray bg-visualizer-small md:bg-visualizer-medium image-discover-hero laptop:bg-visualizer bg-right bg-cover laptop:mt-150px"
    >
      <div class="container h-full mx-auto">
        <div class="flex flex-col justify-around h-full w-full laptop:w-5/12 laptop:ml-24 p-5 md:px-8">
          <div>
            <h2 class="text-white lg:text-55xl md:text-45xl">
              {{ $t("home.cta-2") }}
            </h2>
            <ActionButton target="_self" href="#register" :value="$t('home.free-trial')" bg="orange" fg="white" @click="focusInput" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useIubenda } from 'mars-iubenda-vite';
import RegistrationForm from '~/components/RegistrationForm.vue';

const {youtubeEnabled} = useIubenda()

const registrationForm = ref<typeof RegistrationForm|null>(null)

const focusInput = function() {
  registrationForm.value?.focusInput()
}
</script>

<style scoped>
* {
  scroll-behavior: smooth
}

/* input[type=checkbox] {
  min-width:30px;
} */
</style>
